/**
 * Admin 역할 CRUD. 라우트 admin.php roles 그룹과 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

export const RoleController = {
    index(): void {
        noop("RoleController", "index");
    },
    create(): void {
        const preset = document.getElementById("preset") as HTMLSelectElement | null;
        const code = document.getElementById("code") as HTMLInputElement | null;
        const name = document.getElementById("name") as HTMLInputElement | null;
        const level = document.getElementById("level") as HTMLInputElement | null;
        if (!preset || !code || !name || !level) return;
        preset.addEventListener("change", () => {
            const opt = preset.options[preset.selectedIndex];
            if (opt.value === "") return;
            code.value = opt.value;
            name.value = opt.getAttribute("data-name") ?? "";
            level.value = opt.getAttribute("data-level") ?? "0";
        });
    },
    store(): void {
        noop("RoleController", "store");
    },
    edit(): void {
        noop("RoleController", "edit");
    },
    update(): void {
        noop("RoleController", "update");
    },
    destroy(): void {
        noop("RoleController", "destroy");
    },
};
